import { marked } from 'marked';

marked.setOptions({ breaks: true });

export const convertMarkdownToHtml = (text: string) => {
  let html = marked.parse(text);

  // Add wrapper classes for tables
  if (typeof html === 'string' && html.includes('<table>')) {
    html = html.replace(/<table>/g, '<div class="table-container"><div class="table-wrap"><table>');
    html = html.replace(/<\/table>/g, '</table></div></div>');
  }

  return html;
};

export const convertMarkdownToPlainText = (html: string) => {
  return html
    .replace(/#+\s(.*?)\n/g, '$1\n\n') // 제목 변환
    .replace(/\*\*(.*?)\*\*/g, '$1') // 볼드체 제거
    .replace(/\*(.*?)\*/g, '$1') // 이탤릭체 제거
    .replace(/`(.*?)`/g, '$1') // 인라인 코드 제거
    .replace(/\[(.*?)]\((.*?)\)/g, '$1 ($2)'); // 링크 변환
};

export const getRelativeTimeString = (isoString: string): string => {
  const now = new Date();
  const date = new Date(isoString);
  const diff = (now.getTime() - date.getTime()) / 1000; // 초 단위

  if (diff < 60) {
    return `방금 전`;
  } else if (diff < 3600) {
    return `${Math.floor(diff / 60)}분 전`;
  } else if (diff < 86400) {
    return `${Math.floor(diff / 3600)}시간 전`;
  } else if (diff < 2592000) {
    return `${Math.floor(diff / 86400)}일 전`;
  } else if (diff < 31536000) {
    return `${Math.floor(diff / 2592000)}달 전`;
  }
  return `${Math.floor(diff / 31536000)}년 전`;
};
